import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import defer from 'lodash/defer';
import { AccountPageLoadEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgCountryFlag',
})
export default class CmgCountryFlag extends Vue {
  @Prop({ required: false, type: String })
  countryCode?: string;

  @Prop({ required: false, default: true, type: Boolean })
  clickable?: boolean;

  @Prop({ required: false, default: true, type: Boolean })
  shouldShowName?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  small?: boolean;

  @Prop({ type: String })
  public focusBack?: string;

  get countryFlagUrl(): string {
    const countryCode = (this.countryCode || this.$appStore.state.ui.countryProfile.countryCode).toLowerCase();
    return this.$appStore.state.cms.images.countryFlags[countryCode].default;
  }

  get countryName(): string {
    switch (this.countryCode) {
      case 'US':
        return 'United States';
      case 'CA':
        return 'Canada';
      default:
        return this.$appStore.state.ui.countryProfile.name;
    }
  }

  onClickFlag(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);

    if (!this.clickable) {
      return;
    }

    this.$services.ui.setModalVisibility('editCountryModal', true);
    this.$services.analytics.send(new AccountPageLoadEvent('change-country-flag'));  
    this.$nextTick(() => defer(() => this.$services.ui.focusDiv('.cmg-modal-container')));
  }
}
